import { useEffect, useState } from "react";
import { Check, X } from "lucide-react";
import { http } from "../../lib/api";

const NEW = "__new__";

export const CategoryPicker = ({ value, onPick, testid = "ex-category", placeholder = "Choose category…" }) => {
  const [names, setNames] = useState([]);
  const [typing, setTyping] = useState(null);
  useEffect(() => { http.get("/extras/collections").then(({ data }) => setNames(data || [])).catch(() => {}); }, []);
  const list = value && !names.includes(value) ? [value, ...names] : names;
  if (typing !== null) return (
    <span className="inline-flex items-center gap-1.5">
      <input data-testid={`${testid}-new-input`} autoFocus value={typing} onChange={(e) => setTyping(e.target.value)} placeholder="New category name"
        onKeyDown={(e) => e.key === "Enter" && typing.trim() && (onPick(typing.trim()), setTyping(null))} className="border border-stone-300 bg-white px-2.5 py-1 text-xs rounded-full outline-none focus:border-[#8B6B4A]" />
      <button data-testid={`${testid}-new-save`} disabled={!typing.trim()} onClick={() => { onPick(typing.trim()); setTyping(null); }} className="disabled:opacity-30"><Check size={14} /></button>
      <button onClick={() => setTyping(null)}><X size={14} /></button>
    </span>
  );
  return (
    <select data-testid={testid} value={value || ""} onChange={(e) => (e.target.value === NEW ? setTyping("") : e.target.value && onPick(e.target.value))}
      className="border border-[#D8CDBE] bg-white rounded-full px-3 py-1 text-xs text-[#4A3D30] outline-none focus:border-[#8B6B4A]">
      {!value && <option value="">{placeholder}</option>}
      {list.map((n) => <option key={n} value={n}>{n}</option>)}
      <option value={NEW}>+ New category…</option>
    </select>
  );
};
